import { Button, Typography, makeStyles } from "@material-ui/core"
import { useEffect } from "react"
import { useHistory } from "react-router-dom"
import { useNavigation } from "../../hooks/useNavigation"
import { useApi } from "../../utils/API"
import { colors } from "../../utils/theme"
import Logo from "../atoms/Logo"
import { BaseTemplate } from "../templates/BaseTemplate"

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(4),
    textAlign: "center",
    backgroundColor: colors.primary.cloud,
  },
  logo: {
    marginBottom: theme.spacing(12),
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  subtitle: {
    marginBottom: theme.spacing(4),
    whiteSpace: "pre-line", // Apply CSS for handling newlines
  },
  button: {
    margin: theme.spacing(1),
  },
}))

const DeleteAccountConfirmation = () => {
  const { toDeleteAccountLogin } = useNavigation()
  const history = useHistory()
  const classes = useStyles()
  const { deactivateAccount, initiateAccountAndDataRemoval } = useApi()

  useEffect(() => {
    const userId = localStorage.getItem("userId")
    const jwtToken = localStorage.getItem("jwt")

    if (!userId || !jwtToken) {
      toDeleteAccountLogin()
    }

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      console.log("beforeunload")
      localStorage.removeItem("userId")
      localStorage.removeItem("jwt")
      e.preventDefault()
      e.returnValue = ""
    }

    window.addEventListener("beforeunload", handleBeforeUnload)
    return () => {
      console.log("unmount")
      localStorage.removeItem("userId")
      localStorage.removeItem("jwt")
      window.removeEventListener("beforeunload", handleBeforeUnload)
    }
  }, [toDeleteAccountLogin])

  const handleDelete = async () => {
    const userId = localStorage.getItem("userId")
    const deleteUser = await initiateAccountAndDataRemoval(userId ?? "")
    const response = await deactivateAccount(userId ?? "") //TODO put back in
    if (response.status === 200 || response.status === 201) {
      localStorage.setItem("flashMessage", "Your account has been deleted.")
      toDeleteAccountLogin()
      localStorage.removeItem("userId")
      localStorage.removeItem("jwt")
    } else {
      // Handle error
    }
  }

  const handleCancel = () => {
    history.goBack() // Go back to the previous page
  }

  return (
    <BaseTemplate>
      <div className={classes.container}>
        <Logo className={classes.logo} />
        <Typography variant="h3" gutterBottom className={classes.title}>
          Confirm Account Deletion
        </Typography>
        <Typography variant="body1" gutterBottom className={classes.subtitle}>
          Deleting your account permanently erases all your information and past
          activity. This includes:
        </Typography>
        <ul style={{ textAlign: "left", maxWidth: "600px" }}>
          <li>
            <Typography variant="body1">
              <u>Previous Vira data:</u> Everything you've done using your Vira
              account, including your activity, completed homework, and
              personalized insights.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <u>Clinical trial data:</u> If you're part of a study, your
              information will be removed and won't be used in the analysis.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <u>Practitioner access:</u> Your practitioner will no longer have
              access to your past data.
            </Typography>
          </li>
        </ul>
        <Typography variant="body1" gutterBottom className={classes.subtitle}>
          Once deleted, this data cannot be recovered. Are you sure you want to
          delete your account?
        </Typography>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleDelete}
          className={classes.button}
        >
          Yes, Delete My Account
        </Button>
        <Button
          variant="outlined"
          onClick={handleCancel}
          className={classes.button}
        >
          Cancel
        </Button>
      </div>
    </BaseTemplate>
  )
}

export default DeleteAccountConfirmation
